import { StyledButton } from '../../../assets/styles/sharedStyles/sharedStyles';

const Button = ({ children, contained, white, ...otherProps }) => {
  return (
    <StyledButton white={white ? 1 : 0} contained={contained ? 1 : 0} {...otherProps}>
      {children}
    </StyledButton>
  );
};

export default Button;
